import { DatePicker, Input } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import moment from 'moment';
import React from 'react';
import Item from '../../../components/Form/Item';
import Level from './Level';

const Detail = () => {
  const formik = useFormikContext();
  return (
    <>
      <h4 className="gx-text-md gx-mt-3 gx-mb-3">Update Sanksi Pelanggaran</h4>

      <Item name="Tanggal Kejadian">
        <DatePicker
          onChange={(value) => {
            formik.setFieldValue("date.start", value.format("YYYY-MM-DD"));
            const date = moment(value).add(6, "months");
            formik.setFieldValue("date.end", date.format("YYYY-MM-DD"));
          }}
          style={{ width: 320 }}
        />
        <ErrorMessage component="div" className="gx-text-danger" name="date.start" />
      </Item>

      <Item name="Berlaku Sampai">
        <Input
          readOnly
          style={{ width: 320 }}
          value={formik.values.date.end}
          placeholder={`Pilih tanggal kejadian`}
        />
        <ErrorMessage component="div" className="gx-text-danger" name="date.end" />
      </Item>

      <Level />

      <Item name="Remark">
        <Input.TextArea rows={4} name="remark" value={formik.values.remark} onChange={formik.handleChange} />
        <ErrorMessage component="div" className="gx-text-danger" name="remark" />
      </Item>
    </>
  );
}

export default Detail;